export function formatCreatedAt(dateString) {
  const date = new Date(dateString);
  const now = new Date();

  const sameDay =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);

  const isYesterday =
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear();

  const options = { month: 'short', day: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-US', options);

  if (sameDay) return `Today, ${formattedDate}`;
  if (isYesterday) return `Yesterday, ${formattedDate}`;

  return formattedDate;
}

export function formatDateTime(dateString) {
  const date = new Date(dateString);

  const datePart = date.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
  });

  const timePart = date
    .toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    })
    .toLowerCase(); // pm instead of PM

  return `${datePart} at ${timePart}`;
}

export function timeAgo(dateString) {
  const date = new Date(dateString);
  const now = new Date();

  const seconds = Math.floor((now - date) / 1000);

  if (seconds < 60) return 'just now';

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hr${hours > 1 ? 's' : ''} ago`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} day${days > 1 ? 's' : ''} ago`;

  const weeks = Math.floor(days / 7);
  if (weeks < 4) return `${weeks} week${weeks > 1 ? 's' : ''} ago`;

  return formatDateTime(dateString); // fallback to full date
}


export function formatTourTime(isoString) {
  console.log(isoString)
  const date = new Date(isoString);
  const now = new Date();

  // Start of today
  const todayStart = new Date(now);
  todayStart.setHours(0, 0, 0, 0);

  // Start of tomorrow
  const tomorrowStart = new Date(todayStart);
  tomorrowStart.setDate(todayStart.getDate() + 1);

  // Start of day after tomorrow
  const dayAfterStart = new Date(todayStart);
  dayAfterStart.setDate(todayStart.getDate() + 2);

  const optionsTime = { hour: 'numeric', minute: '2-digit', hour12: true };
  const optionsDate = { weekday: 'short', month: 'short', day: 'numeric' };

  if (date >= todayStart && date < tomorrowStart) {
    return `Today at ${date.toLocaleTimeString([], optionsTime)}`;
  } else if (date >= tomorrowStart && date < dayAfterStart) {
    return `Tomorrow at ${date.toLocaleTimeString([], optionsTime)}`;
  } else {
    return `${date.toLocaleDateString([], optionsDate)} at ${date.toLocaleTimeString([], optionsTime)}`;
  }
}

export function formatOpenHouse(startISO, endISO) {
  const start = new Date(startISO);
  const end = new Date(endISO);

  // Options for day label
  const dayOptions = { weekday: 'long', month: 'short', day: 'numeric' };
  const dayLabel = start.toLocaleDateString(undefined, dayOptions);

  // Options for time
  const timeOptions = { hour: 'numeric', minute: '2-digit', hour12: true };
  const startTime = start.toLocaleTimeString(undefined, timeOptions).toLowerCase();
  const endTime = end.toLocaleTimeString(undefined, timeOptions).toLowerCase();

  const timeRange = `${startTime} - ${endTime}`;

  return { dayLabel, timeRange };
}

export function formatUploadedTag(dateString) {
  if (!dateString) return '';

  const uploadedDate = new Date(dateString);
  const now = new Date();

  const diffMs = now - uploadedDate;
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  // show "New" only if within 24 hours
  const isNew = diffHours < 24;

  let timeLabel = '';

  if (diffMinutes < 1) {
    timeLabel = 'just now';
  } else if (diffMinutes < 60) {
    timeLabel = `${diffMinutes} minute${diffMinutes > 1 ? 's' : ''} ago`;
  } else if (diffHours < 24) {
    timeLabel = `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  } else {
    timeLabel = `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
  }

  return isNew ? `New ${timeLabel}` : timeLabel;
}

export function formatDate(dateString) {
  if (!dateString) return '';

  const date = new Date(dateString);
  const options = { month: 'short', day: 'numeric', year: 'numeric' };

  return date.toLocaleDateString('en-US', options);
}



